import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  HStack,
  Select,
  SelectField,
  Text
} from '@chakra-ui/react';
import { useState } from 'react';

type PaginationRoundProps = {
  currentPage: number;
  dataPerPage: number;
  setDataPerPage: any;
  dataTotal?: number;
  handlePaginate: (pageNumber: number) => void;
};

export const PaginationRound = ({
  setDataPerPage,
  dataPerPage,
  dataTotal,
  handlePaginate
}: PaginationRoundProps) => {
  const [activeStep, setActiveStep] = useState(1);

  const pageNumbers: number[] = [];
  const ter = dataTotal != null ? dataTotal : 0;

  for (let i = 1; i <= Math.ceil(ter / dataPerPage); i++) {
    pageNumbers.push(i);
  }

  const previousButton = () => {
    if (activeStep > 1) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const forwardButton = () => {
    if (activeStep < Math.ceil(ter / dataPerPage)) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  return (
    <HStack w="100%" justifyContent="space-between" alignItems="center">
      <Box w="50%" display="flex" justifyContent="start" alignItems="center">
        <Text
          fontWeight="400"
          fontSize="0.875rem"
          lineHeight="1.5rem"
          color="#5A5A5A"
        >
          Linhas por página
        </Text>
        <Select
          w="70px"
          color="#61596C"
          fontSize="0.875rem"
          value={dataPerPage}
          onChange={(e) => {
            setActiveStep(1);
            handlePaginate(1);
            setDataPerPage(Number(e.target.value));
          }}
          _hover={{}}
          _active={{}}
          _focus={{
            '&:focus': {
              boxShadow: 'none !important'
            }
          }}
          border="none"
        >
          <option>05</option>
          <option>10</option>
          <option>20</option>
          <option>40</option>
        </Select>
      </Box>
      <Box
        w="50%"
        display="flex"
        justifyContent="end"
        alignItems="center"
        gridGap="10px"
      >
        <Text
          m=" 0 38px 0 0 !important"
          fontWeight="400"
          fontSize="0.875rem"
          lineHeight="1.5rem"
          color="#5A5A5A"
        >
          Exibindo de {activeStep} até {Math.ceil(ter / dataPerPage)} de &nbsp;
          {Math.ceil(ter / dataPerPage)}
        </Text>
        <Button
          w="4.16px"
          h="6.99px"
          bg="transparent"
          m="0 20px 0 0 !important"
          onClick={() => {
            previousButton();
          }}
          color={'#D2D2D2'}
          _hover={{}}
          _active={{}}
          _focus={{
            '&:focus': {
              boxShadow: 'none !important'
            }
          }}
        >
          <ChevronLeftIcon />
        </Button>
        {pageNumbers.map((pageNumber, index) => {
          return (
            <Box
              key={index}
              w="32px"
              h="32px"
              p="6px"
              bg="#146CFA"
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRadius="50%"
              color="#FFFFFF"
              onClick={() => {
                handlePaginate(pageNumber);
                setActiveStep(pageNumber);
              }}
              cursor={'pointer'}
            >
              {pageNumber}
            </Box>
          );
        })}
        <Button
          w="4.16px"
          h="6.99px"
          bg="transparent"
          m="0 0 0 20px !important"
          onClick={() => {
            forwardButton();
          }}
          color="#D2D2D2"
          _hover={{}}
          _active={{}}
          _focus={{
            '&:focus': {
              boxShadow: 'none !important'
            }
          }}
        >
          <ChevronRightIcon />
        </Button>
      </Box>
    </HStack>
  );
};
